<template>
  <div
    v-if="!printerFriendly && showReportOptions"
    class="container-fluid ">
    <div class="row rd-gridsystem-scrollbar-wrap compareByFilter">
      <div class="rdResponsiveColumn col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="container-fluid ">
          <div class="row">
            <div class="rdResponsiveColumn col-lg-5 col-md-5 col-sm-12 col-xs-12 divSpacer">
              <div class="container-fluid optionsContainer">
                <div class="row">
                  <div class="optionsHeader col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    Data Filter
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 optionsElement">
                    <div>
                      <div>
                        <label
                          for="islCategoryFilter"
                          class="rdThemeInputCaption">Category</label>
                      </div>
                      <div>
                        <select
                          id="islCategoryFilter"
                          v-model="categoryFilterId"
                          class="rdThemeInput"
                          style="width: 200px;">
                          <option
                            v-for="item in dataFilterCategories"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }}</option>
                        </select>
                      <!-- <span
                        v-if="showDebugIds"
                              class="debugIds">
                              {{ GS.categoryId }} Count: {{ categories.length }}</span> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 optionsElement">
                    <div>
                      <div>
                        <label
                          for="islStratFilter"
                          class="rdThemeInputCaption">Disability Status & Type</label>
                      </div>
                      <div>
                        <select
                          id="islStratFilter"
                          v-model="stratFilterId"
                          class="rdThemeInput"
                          style="width: 200px;">
                          <option
                            v-for="item in stratifications"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }}</option>
                        </select>
                      </div>
                    <!-- <span
                      v-if="showDebugIds"
                      class="debugIds">
                            {{ GS.categoryId }} Count: {{ categories.length }}</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rdResponsiveColumn col-lg-5 col-md-5 col-sm-12 col-xs-12 divSpacer">
              <div class="container-fluid optionsContainer">
                <div class="row">
                  <div class="optionsHeader col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    Display Options
                  </div>
                </div>
                <div class="row ">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 optionsElement">
                    <div>
                      <label class="form-check">
                        <input
                          v-model="showCI"
                          type="checkbox"
                          class="form-check-input">
                        <span class="form-check-label">Show Confidence Interval</span>
                      </label>
                    </div>
                    <div>
                      <label class="form-check">
                        <input
                          v-model="showWN"
                          type="checkbox"
                          class="form-check-input">
                        <span class="form-check-label">Show Weighted No.</span>
                      </label>
                    </div>
                    <div>
                      <label class="form-check">
                        <input
                          v-model="hideMissingDataRows"
                          type="checkbox"
                          class="form-check-input">
                        <span class="form-check-label">Hide missing data rows</span>
                      </label>
                    </div>
                    <div class="textElement">
                      Display options will not be applied to the CSV export.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rdResponsiveColumn col-lg-3 col-md-3 col-sm-12 col-xs-12" />
          </div>
          <div class="row">
            <div class="rdResponsiveColumn col-lg-4 col-md-4 col-sm-12 col-xs-12 updateBtn">
              <div id="divUpdateBtn">
                <!-- <input
                :class="{ButtonDisabled: !goEnabled}"
                        type="button"
                        value="GO"
                        class="span2"
                        @click="goButtonClicked"> -->
                <input
                  type="button"
                  value="Update"
                  class="span2"
                  @click="update">
              </div>
            </div>
            <div class="rdResponsiveColumn col-lg-2 col-md-2 col-sm-2 col-xs-2 hideBtn">
              <div>
                <a
                  href="#"
                  @click.prevent="setShowReportOptions(false)">Hide</a>
              </div>
            </div>
            <div class="rdResponsiveColumn col-lg-3 col-md-2 col-sm-12 col-xs-12" />
            <div class="rdResponsiveColumn col-lg-3 col-md-5 col-sm-12 col-xs-12" />
          </div>
        </div>
      </div>
    </div>
</div></template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      categoryFilterId: '',
      stratFilterId: '',
      showCI: true,
      showWN: true,
      hideMissingDataRows: false,
    };
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      crDataRaw: state => state.CR.crDataRaw,
      showReportOptions: state => state.CR.flags.showReportOptions,
      showCategoryIds: state => state.CR.showCategoryIds,
      reportOptionsGo: state => state.CR.reportOptionsGo,
    }),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    categoriesRaw() {
      return this.$store.getters['CR/categoriesRaw'];
    },
    categoriesFiltered() {
      return this.$store.getters['CR/categoriesFiltered'];
    },
    dataFilterCategories() {
      return _.concat({ id: '', name: 'Display All' }, this.categoriesRaw);
    },
    stratifications() {
      return _.concat(
        { id: '', name: 'Display All' },
        _(this.crDataRaw).map('s1').uniq()
          .compact() // remove undefined values which occur if the indicator has no data for selected columns
          .map(s1 => this.lku.Stratification[s1])
          .orderBy('sort', 'asc')
          .value(),
      );
    },
  },
  watch: {
    reportOptionsGo() {
      this.setLocalDataToState();
    },
  },
  created() {
    this.setLocalDataToState();
  },
  methods: {
    setShowReportOptions(bool) {
      this.$store.commit('CR/setShowReportOptions', bool);
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
    setLocalDataToState() {
      this.categoryFilterId = this.reportOptionsGo.categoryFilterId;
      this.stratFilterId = this.reportOptionsGo.stratFilterId;
      this.showCI = this.reportOptionsGo.showCI;
      this.showWN = this.reportOptionsGo.showWN;
      this.hideMissingDataRows = this.reportOptionsGo.hideMissingDataRows;
    },
    update() {
      this.$store.commit('CR/setReportOptionsGo', {
        categoryFilterId: this.categoryFilterId,
        stratFilterId: this.stratFilterId,
        showCI: this.showCI,
        showWN: this.showWN,
        hideMissingDataRows: this.hideMissingDataRows,
      });
      if (this.categoryFilterId) {
        const newShowCategoryIds = _(this.categoriesFiltered).reduce((acc, obj) => {
          acc[obj.id] = (obj.id === this.categoryFilterId);
          return acc;
        }, {});
        this.$store.commit('CR/setShowCategoryIds', newShowCategoryIds);
      }
      this.$store.dispatch('CR/triggerInteraction', { type: 'CRO' });
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CR/CRReportOptions.vue